import React from 'react';
import { NavLink } from "react-router-dom";

const AdminNav = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        <NavLink className="navbar-brand" to="/">Kitten</NavLink>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink className="nav-link" to="/">Usuarios</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/clientes">Clientes</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/encuestas">Encuestas</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/herramientas">Herramientas</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/envios-masivos">Envíos</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/envios-whatsapp">Envíos WhatsApp</NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default AdminNav;
